import React, { useEffect } from "react";
import {
  InboxArrowDownIcon,
  TruckIcon,
  ClipboardDocumentCheckIcon,
} from "@heroicons/react/24/outline";
import { aFechaConDiagonales } from "../../tools/ConversionFechas";
import { classNames } from "../../tools/ClassNames";

const GridPedido3 = ({
  menosRef,
  esProveedor = false,
  conta = false,
  control = false,
  handleBlur,
  iconosLabels,
  handleIncDec,
  recepcion,
  columnasIconos,
  columnas,
  campoPrincipal,
  setFilter,
  data,
  seleccionado,
  fechaActual,
  setPedidos,
  handleNumEnvio,
  handlePedidos,
  pedidos,
  handleIdProdProv,
  setFechaActual,
  handleFecha,
  handleChecked,
  setModal,
  setNumEnvio,
  numEnvio,
  setPedidoSeleccionado,
  inputLabels,
}) => {
  const setFechaSeleccionado = () => {
    let seleccionadoParam = seleccionado;
    seleccionadoParam.FechaEnvio = aFechaConDiagonales(fechaActual);
    setPedidoSeleccionado(seleccionadoParam);
  };

  const formateoString = (label) => {
    const option = {
      Pagado: "Facturado",
      "Recepción Parcial": "Recepción incompleta",
    };
    return option[label] || label;
  };

  useEffect(() => {
    console.log("Entrando");
    if (!recepcion) {
      setNumEnvio("");
      setFechaSeleccionado();
    }
  }, []);

  return (
    <div
      role="list"
      className="divide-white/40  bg-primarioMira p-2 rounded-lg shadow-sm shadow-white w-[100%] xl:w-[80%] mx-auto elementFadeIn flex flex-col"
    >
      <div className="p-2 bg-secundarioMira my-1 rounded-lg mb-4">
        <div className="flex items-center flex-col md:flex-row md:justify-between">
          <div className="flex flex-row gap-4 w-full">
            <span
              className={classNames(
                ["Pagado", "Entregado", "Recibido"].includes(
                  seleccionado.Estatus,
                )
                  ? "bg-blue-200 text-blue-900"
                  : ["Revisado"].includes(seleccionado.Estatus)
                    ? "bg-green-300 text-green-900"
                    : ["Recepción Parcial", "Entrega Parcial"].includes(
                          seleccionado.Estatus,
                        )
                      ? "bg-yellow-200 text-yellow-900"
                      : ["Pendiente de Recibir", "Despachado"].includes(
                            seleccionado.Estatus,
                          )
                        ? "bg-orange-200 text-orange-900"
                        : [
                            "Pendiente",
                            "Pedido",
                            "Pendiente de Revisar",
                          ].includes(seleccionado.Estatus) &&
                          "bg-red-200 text-orange-900",
                " /truncate text-3xl font-medium flex text-start rounded-lg px-8 py-2.5",
              )}
            >
              {/*seleccionado[campoPrincipal] || seleccionado['IdEnvio']*/}
              {esProveedor ? (
                `#${seleccionado["IdEnvio"] || seleccionado[columnas[0].fieldName]}`
              ) : (
                <div className="flex flex-col">
                  <div className="flex flex-row gap-2 justify-between">
                    <p className="text-2xl">Envío</p>
                    <p className="/text-gray-100 text-2xl">{`#${seleccionado["IdEnvio"]}`}</p>
                  </div>
                  <div className="flex flex-row gap-2 justify-between">
                    <p className="text-2xl">Pedido</p>
                    <p className="/text-gray-100 text-2xl">{`#${seleccionado["IdPedido"]}`}</p>
                  </div>
                </div>
              )}
            </span>
            <div className=" self-end flex">
              <p className="text-gray-100">{`(${formateoString(seleccionado.Estatus)})`}</p>
            </div>
          </div>

          <div className="md:ml-5 flex flex-col md:flex-row w-full justify-end">
            <div className="/truncate text-xl text-white justify-between flex flex-col">
              <div className="flex flex-col md:flex-row justify-between md:gap-4">
                <div className="flex flex-col justify-end">
                  <p className="font-medium text-2xl my-1">
                    {seleccionado?.Bodega}
                  </p>
                  <p className="text-gray-400 text-sm mb-2 lg:mb-0">
                    {/* seleccionado?.Proveedor */} Ingrese el número y la fecha
                    del envío para continuar
                  </p>
                </div>

                {esProveedor &&
                ["Revisado", "Pagado"].includes(seleccionado.Estatus)
                  ? null
                  : !recepcion &&
                    !["Entregado", "Despachado"].includes(
                      seleccionado.Estatus,
                    ) && (
                      <div className="text-sm text-gray-400 flex flex-col md:flex-row justify-end gap-2">
                        <div className="flex flex-col justify-between">
                          <label
                            htmlFor="NoEnvioProv"
                            className="text-gray-400"
                          >
                            Tu número de envío
                          </label>
                          <div className="flex flex-row">
                            <input
                              name="NoEnvioProv"
                              autoComplete={"off"}
                              type="text"
                              className={classNames(
                                !numEnvio ? "animate-pulse" : "",
                                "rounded-md p-2 text-center inline text-black w-full",
                              )}
                              value={seleccionado?.NoEnvioProv}
                              autoFocus={true}
                              //onBlur={() => handleBlur()}
                              onChange={(e) => setNumEnvio(e.target.value)}
                            ></input>
                          </div>
                        </div>

                        {esProveedor && (
                          <div className="flex flex-col justify-between">
                            <label
                              htmlFor="FechaEnvio"
                              className="text-gray-400"
                            >
                              Fecha de envío
                            </label>
                            <div className="flex flex-row">
                              <input
                                name="FechaEnvio"
                                type="date"
                                min="2023-01-01"
                                max="2100-12-12"
                                className="rounded-md p-2 text-center md:m-auto block text-black w-full"
                                value={fechaActual}
                                onChange={(e) =>
                                  handleFecha(
                                    e,
                                    pedidos,
                                    setPedidos,
                                    setFechaActual,
                                    seleccionado,
                                  )
                                }
                              ></input>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
              </div>
            </div>
          </div>
        </div>
        <p className="text-white text-xl font-semibold">
          {esProveedor &&
            ["Revisado"].includes(seleccionado.Estatus) &&
            `Tu número de envío ${seleccionado[columnas[0].fieldName]}`}
        </p>
      </div>

      {Object.values(pedidos).length > 0 &&
        Object.values(pedidos)
          .flat(Infinity)
          .find((e) => e[campoPrincipal] === seleccionado[campoPrincipal])
          .Productos.map((item, index) => {
            return (
              <div
                key={index}
                className={classNames(
                  item?.selected ? "bg-secundarioMira" : "bg-primarioMira",
                  `p-2 transition duration-500 ease rounded-lg my-1`,
                )}
              >
                {" "}
                {/* no funciona y debería */}
                <div className={"flex flex-col md:flex-row justify-end py-4"}>
                  {/*
              <div className="flex flex-row">
                  <div className="flex flex-row w-1/8 md:hidden px-2 ">
                      {
                        (
                          ([  'Pendiente', 'Recepción Parcial', 'Pedido','Entrega Parcial','Pendiente de Revisar'].includes(seleccionado.Estatus)) 
                           ? (  
                        <input
                        name="selected"
                        type="checkbox"
                        checked={item.selected?true:false}
                        disabled={(!numEnvio || (item[columnasIconos[2].fieldName] === 0 && recepcion))?true:false}
                        className="my-auto text-azulBrillanteMira mr-4 p-3 rounded-md transition duration-500 ease"
                        onChange={(e) =>  handleChecked(e, index, pedidos, setPedidos, numEnvio, fechaActual, seleccionado, campoPrincipal)}
                        ></input>
                      ): null)}
                  </div>
                  <div className="flex flex-row w-7/8 md:hidden">
                    <p className="w-full text-lg text-white font-medium">{item?.Producto}</p>
                  </div>
              </div>
                */}
                  {[
                    "Pendiente",
                    "Entrega Parcial",
                    "Pedido",
                    "Pendiente de Revisar",
                    "Recepción Parcial",
                  ].includes(seleccionado.Estatus) ? (
                    conta ? null : (
                      <input
                        name="selected"
                        type="checkbox"
                        checked={item.selected ? true : false}
                        disabled={!numEnvio && recepcion ? true : false}
                        className=" md:flex my-auto  md:mt-4 text-azulBrillanteMira mr-4 p-3 rounded-md transition duration-500 ease"
                        onChange={(e) =>
                          handleChecked(
                            e,
                            index,
                            pedidos,
                            setPedidos,
                            numEnvio,
                            fechaActual,
                            seleccionado,
                            campoPrincipal,
                          )
                        }
                      ></input>
                    )
                  ) : null}
                  <div className="flex flex-col p-2">
                    <div className="hidden md:flex flex-row gap-2">
                      <dl className="text-xl text-white font-medium">
                        {item?.Producto}
                      </dl>
                    </div>
                    <Iconos
                      esProveedor={esProveedor}
                      item={item}
                      columnasIconos={columnasIconos}
                      seleccionado={seleccionado}
                      Idx={index}
                      iconosLabels={iconosLabels}
                    />
                  </div>
                  <h3 className="flex-auto truncate text-lg font-medium leading-6 text-white">
                    {""}
                  </h3>
                  {control ? (
                    conta ? null : item?.CostoAnterior > 0 ? (
                      <div className="flex flex-row gap-4 justify-end mt-4">
                        <div className="flex flex-col justify-end">
                          <p className="text-gray-100">Costo de envío</p>
                          {seleccionado.Estatus !== "Pendiente de Revisar" ? (
                            <p className="text-gray-100 text-3xl">
                              {Intl.NumberFormat("es-GT", {
                                style: "currency",
                                currency: "GTQ",
                              }).format(item.CostoAnterior)}
                            </p>
                          ) : (
                            <input
                              name="Cantidad"
                              type="number"
                              disabled={!numEnvio ? true : false}
                              className="p-2 text-center w-1/2 text-black border border-white rounded"
                              value={item[inputLabels[0].fieldName]}
                              onChange={(e) =>
                                handlePedidos(
                                  e,
                                  index,
                                  pedidos,
                                  setPedidos,
                                  seleccionado,
                                  setModal,
                                  campoPrincipal,
                                )
                              }
                            ></input>
                          )}
                        </div>
                        <div className="flex flex-col justify-end">
                          <p className="text-gray-100">Costo revisado</p>
                          {seleccionado.Estatus !== "Pendiente de Revisar" ? (
                            <p className="text-gray-100 text-3xl">
                              {Intl.NumberFormat("es-GT", {
                                style: "currency",
                                currency: "GTQ",
                              }).format(item.Costo)}
                            </p>
                          ) : (
                            <div>
                              <input
                                name="Cantidad"
                                type="number"
                                disabled={!numEnvio ? true : false}
                                className="p-2 text-center w-1/2 text-black border border-white rounded"
                                value={item[inputLabels[0].fieldName]}
                                onChange={(e) =>
                                  handlePedidos(
                                    e,
                                    index,
                                    pedidos,
                                    setPedidos,
                                    seleccionado,
                                    setModal,
                                    campoPrincipal,
                                  )
                                }
                              ></input>
                            </div>
                          )}
                        </div>
                        <div className="flex items-end">
                          {/*item.CostoAnterior > item.Costo ?
                      <ArrowDownCircleIcon className="w-5 h-5 text-green-500"/>:
                      <ArrowUpCircleIcon className="w-5 h-5 text-red-500"/>
                    */}
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col /my-auto justify-end">
                        {/*
                        <p className="text-gray-100">{seleccionado.Estatus !== 'Pendiente de Revisar' ? "" : ""}</p>
                            {seleccionado.Estatus !== 'Pendiente de Revisar'?
                        <p className="text-gray-100 text-3xl">{Intl.NumberFormat('es-GT', {style:'currency', currency:"GTQ"}).format(item.Costo)}</p>
                      */}
                        {[
                          "Pendiente de Revisar",
                          "Recepción Parcial",
                          "Pendiente",
                        ].includes(seleccionado.Estatus) && (
                          <div className="flex flex-row justify-end">
                            <div className="rounded-l bg-gray-50 flex p-2 border-none border-gray-400">
                              <p className="m-auto text-gray-700 font-medium">
                                Q.
                              </p>
                            </div>
                            <input
                              name="Cantidad"
                              type="number"
                              disabled={!numEnvio ? true : false}
                              className="p-2 w-1/3 text-black border border-white rounded-r border-none text-end"
                              value={item[inputLabels[0].fieldName]}
                              onChange={(e) =>
                                handlePedidos(
                                  e,
                                  index,
                                  pedidos,
                                  setPedidos,
                                  seleccionado,
                                  setModal,
                                  campoPrincipal,
                                )
                              }
                            ></input>
                          </div>
                        )}
                      </div>
                    )
                  ) : ["Entregado", "Pagado", "Recibido"].includes(
                      seleccionado.Estatus,
                    ) ? null : Object.hasOwnProperty(
                      seleccionado["CantidadDespachada"],
                    ) &&
                    seleccionado["CantidadPedido"] ===
                      seleccionado["CantidadDespachada"] ? null : (
                    <Inputs
                      menosRef={menosRef}
                      handleBlur={handleBlur}
                      conta={conta}
                      handleIncDec={handleIncDec}
                      numEnvio={numEnvio}
                      fechaActual={fechaActual}
                      Idx={index}
                      handleNumEnvio={handleNumEnvio}
                      setPedidos={setPedidos}
                      pedidos={pedidos}
                      item={item}
                      seleccionado={seleccionado}
                      handlePedidos={handlePedidos}
                      handleIdProdProv={handleIdProdProv}
                      setModal={setModal}
                      columnasIconos={columnasIconos}
                      inputLabels={inputLabels}
                      campoPrincipal={campoPrincipal}
                      esProveedor={esProveedor}
                    />
                  )}
                  {conta &&
                    ["Pendiente de Revisar", "Pagado", "Revisado"].includes(
                      seleccionado.Estatus,
                    ) && (
                      <div className="flex flex-col justify-end">
                        <p className="text-gray-100"></p>
                        <p className="text-gray-100 text-3xl">
                          {Intl.NumberFormat("es-GT", {
                            style: "currency",
                            currency: "GTQ",
                          }).format(item.Costo)}
                        </p>
                      </div>
                    )}
                </div>
              </div>
            );
          })}
    </div>
  );
};

export default GridPedido3;

const Inputs = ({
  Idx,
  item,
  campoPrincipal,
  setPedidos,
  menosRef,
  numEnvio,
  setModal,
  handlePedidos,
  seleccionado,
  pedidos, // si no funciona el check con pedidos, usarlo con data
  columnasIconos,
  handleBlur,
  inputLabels,
  handleIncDec,
  conta,
}) => {
  return (
    <div className="flex flex-col gap-1  2xl:flex-row ">
      <div className="flex flex-col 3xl:w-1/2 justify-end ">
        {![
          "Entrega Parcial",
          "Pedido",
          "Pendiente de Revisar",
          "Pendiente",
          "Recepción Parcial",
        ].includes(seleccionado.Estatus) || conta ? null : (
          <div className="flex-col flex">
            <label
              htmlFor="Cantidad"
              className="text-gray-400 text-sm text-start"
            >
              {inputLabels[0].fieldName}
            </label>

            <div className="flex flex-row justify-end">
              <button
                className="bg-azulBrillanteMira text-white p-2 rounded-l-md w-1/4"
                name="restar"
                onClick={(e) =>
                  handleIncDec(
                    e,
                    pedidos,
                    seleccionado,
                    campoPrincipal,
                    Idx,
                    columnasIconos[2].fieldName,
                    columnasIconos[3].fieldName,
                    menosRef,
                  )
                }
              >
                -
              </button>

              <input
                name="Cantidad"
                type="number"
                ref={menosRef}
                onClick={(e) => (e.target.value = "")}
                onBlur={() => handleBlur(Idx, seleccionado)}
                disabled={!numEnvio ? true : false}
                className="p-2 text-center text-blackborder border-white w-1/2"
                value={
                  item[columnasIconos[2].fieldName] ||
                  item[columnasIconos[3].fieldName]
                }
                //value={item["Cantidad"]}
                onChange={(e) =>
                  handlePedidos(
                    e,
                    Idx,
                    pedidos,
                    setPedidos,
                    seleccionado,
                    setModal,
                    columnasIconos[2].fieldName,
                    columnasIconos[3].fieldName,
                  )
                }
              ></input>

              <button
                className="bg-azulBrillanteMira text-white p-2 rounded-r-md w-1/4"
                name="sumar"
                onClick={(e) =>
                  handleIncDec(
                    e,
                    pedidos,
                    seleccionado,
                    campoPrincipal,
                    Idx,
                    columnasIconos[2].fieldName,
                    columnasIconos[3].fieldName,
                    menosRef,
                  )
                }
              >
                +
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const Iconos = ({
  item,
  columnasIconos,
  seleccionado,
  Idx,
  iconosLabels,
  esProveedor,
}) => {
  return (
    <div
      className={classNames(
        [
          "Entregado",
          "Revisado",
          "Pagado",
          "Recibido",
          "Pendiente de Recibir",
          "Recepción Parcial",
        ].includes(seleccionado.Estatus)
          ? "flex-col md:flex-row"
          : "flex-col md:flex-row",
        "flex gap-2 mt-4",
      )}
    >
      <div className="flex flex-row justify-between gap-2">
        <InboxArrowDownIcon className="w-5 h-5 text-gray-400 3xl:mx-auto" />
        <div className="truncate text-sm text-gray-400 flex flex-row gap-1">
          {/*<p className="text-white font-medium">{seleccionado.Productos[Idx][columnasIconos[0]?.fieldName] || seleccionado.Productos[Idx]['CantidadEnvio'] || 0}</p><p>{ iconosLabels[0].fieldName }</p>*/}
          <p className="text-white font-medium">
            {item[columnasIconos[0]?.fieldName] || item["CantidadEnvio"] || 0}
          </p>
          <p>{iconosLabels[0].fieldName}</p>
        </div>
      </div>

      <div className="flex flex-row justify-between gap-2">
        <TruckIcon className="w-5 h-5 text-gray-400  3xl:mx-auto" />
        <div className=" truncate text-sm text-gray-400 flex flex-row gap-1">
          <p className="text-white font-medium">
            {item[columnasIconos[1]?.fieldName] ||
              item["CantidadRecibida"] ||
              0}
          </p>
          <p>{iconosLabels[1].fieldName}</p>
        </div>
        {esProveedor && (
          <div className="flex text-sm text-gray-400 text-center flex-row gap-1">
            <p className="text-gray-100">{item["CantidadDespachada"]}</p>
            <p>Unidades despachadas</p>
          </div>
        )}
      </div>

      <div className="flex flex-row justify-between gap-2">
        <ClipboardDocumentCheckIcon className="w-5 h-5 text-gray-400 3xl:mx-auto" />
        <div className=" truncate text-sm text-gray-400 flex flex-row gap-1">
          <p className="text-white font-medium">
            {item[columnasIconos[2]?.fieldName] ||
              item[columnasIconos[3]?.fieldName] ||
              item["Saldo"] ||
              0}
          </p>
          <p>{iconosLabels[2].fieldName}</p>
        </div>
      </div>
    </div>
  );
};

